import React, { Fragment } from 'react'
import { FormInput } from '@myxplor/forms'
import RemoteTypeAheadSelect, { TypeAheadSelect } from '../../../../ui/forms/type-ahead'
import { rolePositions, roleIsOther } from './states'
import { PersonelErrors } from './personnel-errors'

export const defaultValues = {
  personnel: undefined,
  xplorUser: undefined,
  PRODARANumber: undefined,
  ProviderRoles: [
    {
      position: undefined,
      positionText: undefined,
    },
  ],
}

export const Personnel = ({
  onChange,
  provider_registration_id,
  values,
  errors = {},
  errorAtKey,
}) => (
  <fieldset>

    <div>
      <RemoteTypeAheadSelect
        name="personnel"
        label="Xplor Personnel Record"
        required
        hint="Select a personnel in Xplor"
        onChange={onChange}
        errors={errors.personnel}
        apiEndPoint={`/api/provider-registrations/${provider_registration_id}/care-personnel`}
        optionsFilter={options =>
          options.map(({ id, first_name, last_name, care_id }) => ({
            value: id,
            label: `${first_name} ${last_name} - ${care_id}`,
          }))
        }
      />

      <PersonelErrors errors={errors} />
      </div>
      <FormInput
        name="PRODARANumber"
        label="PRODA ID"
        required
        compact
        hint={
          <Fragment>
            The personnel must have registered for a <a href="https://proda.humanservices.gov.au" rel="noopener noreferrer" target="_blank">PRODA ID</a> with the government
          </Fragment>
        }
        value={values.PRODARANumber}
        maxLength={10}
        onChange={onChange}
        errors={errors.PRODARANumber}
        htmlInput={{
          pattern: '[0-9]*',
        }}
      />

      <TypeAheadSelect
        name="ProviderRoles[0].position"
        value={values.ProviderRoles[0].position}
        label="Current Position"
        errors={errorAtKey({ key: 'ProviderRoles[0].position', errors })}
        required
        compact
        options={rolePositions}
        onChange={onChange}
      />

      {roleIsOther(values.ProviderRoles[0]) && (
        <FormInput
          name="ProviderRoles[0].positionText"
          value={values.ProviderRoles[0].positionText}
          errors={errorAtKey({ key: 'ProviderRoles[0].positionText', errors })}
          label="Position of the personnel"
          hint="Since you selected &quot;Other&quot;, please describe the role"
          maxLength={150}
          onChange={onChange}
          required
          compact
        />
      )}

  </fieldset>
)



// WEBPACK FOOTER //
// ./src/providers-registrations/personnel-list/register-mancon-action/form/personnel.jsx